module.exports = __webpack_public_path__ + "media/RMR Quick Tip Use your card 4.03e98178.mp4";